/**
 * Toaster wrapper — F-008 Phase 5 (Task 5.1).
 *
 * First use of sonner/toast in the webapp. Mounted once in `main.tsx` so any
 * call to `toast.success(...)` / `toast.error(...)` anywhere in the SPA shows
 * a toast.
 */
'use client';

import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

/**
 * SIM-026: hoisted to module scope to avoid re-creating the object on every
 * Toaster render. The `classNames` are static shadcn tokens — no runtime deps.
 */
const defaultToastOptions: ToasterProps['toastOptions'] = {
  classNames: {
    toast:
      'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
    description: 'group-[.toast]:text-muted-foreground',
    actionButton:
      'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
    cancelButton:
      'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
  },
};

export function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      theme="system"
      className="toaster group"
      toastOptions={defaultToastOptions}
      {...props}
    />
  );
}
